import Component from '../../classes/Component';
import variables from "../../variables";
import {apiHelper, getMeta, resetChoice} from "../../helpers/_utilities";
import {$data} from "../../helpers/data";
import debounce from "lodash.debounce";
import {$dom} from "../../helpers/dom";
import {$events} from "../../helpers/events";
import Choices from "choices.js";

const targetSelectSelector = '.'+variables.classNames.searchSelect;
const isCitySelectClassName = 'is-city-search';
const excludedCityOptions = [
    'Весь Казахстан',
    'Вся Беларусь',
    'Вся Россия'
];
const searchCitiesUrl = '/searchCities';

const {
    list: listClassName,
    listDropdown: listDropdownClassName,
    containerOuter: containerClassName,
    input: inputClassName
} = variables.choicesOptions.classNames;

export default function () {

    return new Component({
        name: 'searchSelect',
        requiredTargets: targetSelectSelector,
        onCreate() {
            this.fields = {};
        },
        onInit() {

            const isCitySelect = selectEl => $dom.hasClass(selectEl, isCitySelectClassName);

            this.updateField = (id, updates) => {
                if (this.fields.hasOwnProperty(id)) {
                    this.fields[id] = {
                        ...this.fields[id],
                        ...updates
                    }
                }
            }

            this.makeRequest = id => {
                let field = this.fields[id];
                if (!field) return;

                let params = {
                    page: field.page,
                    withR: true,
                    locale: getMeta('locale'),
                    _type: 'query',
                };

                if (field && field.searchQuery) {
                    params = $data.merge(params, {
                        term: field.searchQuery,
                        q: field.searchQuery,
                        _type: 'query:append',
                    })
                }

                if (Boolean(id)) this.updateField(id, {loadDisabled: true});

                return apiHelper({
                    url: searchCitiesUrl,
                    params,
                    method: 'GET'
                })
                    .then(response => {
                        let {results} = response;
                        if (results) {
                            results = results
                                .filter(({text}) => !excludedCityOptions.includes(text))
                                .map(result => {
                                    const {text, id} = result;
                                    return {label: text, value: id, customProperties: result}
                                })
                            ;

                            return results
                        }

                        return []
                    })
                    .finally(() => this.updateField(id, {loadDisabled: false}))

            };

            this.handleScroll = debounce(({target}) => {
                const {scrollTop, offsetHeight, scrollHeight} = target;
                const select = target.closest('.'+containerClassName).querySelector(targetSelectSelector);
                const percent = Math.ceil((scrollTop + offsetHeight) / scrollHeight * 100);
                const id = $dom.attr(select, 'id');

                if (!id) return;

                const field = this.fields[id];
                const {loadDisabled, instance} = field;

                const $that = this;

                if (percent > 95 && !loadDisabled) {
                    instance.setChoices(function() {
                        return $that.makeRequest(id)
                            .then(response => {
                                $that.updateField(id, {
                                    page: field.page+=1
                                });

                                return response
                            })
                    }, 'value', 'label', false)
                }
            }, variables.inputDebounce);

            this.handleSearch = debounce(async e => {
                const {detail} = e;
                const id = $dom.attr(e.target, 'id');

                if (!id) {
                    this.idWarn(e.target);
                    return;
                }

                const field = this.fields[id];

                this.updateField(id, {
                    page: 1,
                    searchQuery: detail.value
                });

                const result = await this.makeRequest(id);
                this.updateField(id, {page: 2});

                field.instance.setChoices(result, 'value', 'label', true);
            }, variables.inputDebounce);

            this.resetItems = async id => {
                const field = this.fields[id];

                if (!field || !isCitySelect(field.element)) return;

                this.updateField(id, {
                    searchQuery: '',
                    page: 1
                });

                resetChoice(field.instance);

                const result = await this.makeRequest(id);
                this.updateField(id, {page: 2});

                field.instance.setChoices(result, 'value', 'label', true)
            };

            this.handleSearchFieldInput = ({target}) => {
                const select = target
                    .closest('.'+containerClassName)
                    .querySelector(targetSelectSelector);

                const id = $dom.attr(select, 'id');
                if (target.value === '' && id) this.resetItems(id)
            };

            this.handleChoice = ({target}) => {
                const fieldId = target.getAttribute('id');

                if (this.fields.hasOwnProperty(fieldId))
                    this.resetItems(fieldId)
            };

            $dom.each(this.targets, async target => {
                const id = $dom.attr(target,'id');

                if (id) {
                    const instance = new Choices(target, {
                        ...variables.choicesOptions,
                        resetScrollPosition: false,
                        shouldSort: false,
                        searchResultLimit: 25,
                        placeholder: true,
                        renderSelectedChoices: false
                    });

                    this.fields[id] = {
                        element: target,
                        instance,
                        loadDisabled: false,
                        searchQuery: '',
                        page: 1
                    };

                    if (!isCitySelect(target)) return;

                    const listElement = $dom.get(
                        `.${listDropdownClassName} .${listClassName}`,
                        instance.containerOuter.element
                    );

                    $events.add('scroll', listElement, this.handleScroll);

                    const field = this.fields[id];

                    if (field) {
                        const results = await this.makeRequest(id);

                        field.instance.setChoices(results, 'value', 'label', true);
                        this.updateField(id, {page: field.page+=1})
                    }
                }
            });

            $events
                .delegate
                .on('search', targetSelectSelector+'.'+isCitySelectClassName, this.handleSearch)
                .on('input', `.${listDropdownClassName} .${inputClassName}`, this.handleSearchFieldInput)
                .on('choice', window, this.handleChoice)
        },
        onDestroy() {
            Object.values(this.fields).forEach(({instance}) => {
                if(instance instanceof Choices) {
                    instance.destroy();
                }
            })

            this.fields = {};

            $events
                .delegate
                .off('search', targetSelectSelector, this.handleSearch)
                .off('input', `.${listDropdownClassName} .${inputClassName}`, this.handleSearchFieldInput)
                .off('choice', window, this.handleChoice)
        }
    })
}
